import { useAuthState } from "@/lib/auth/useUser";

/** Returns true if the current user has a permission. Supports wildcards:
 *  - "*" matches everything (superuser)
 *  - "feature.*" matches every action in that feature
 *  - "" (empty) means any authenticated user — for surfaces whose real
 *    access control is per-record on the backend (e.g. planning invites)
 *  - exact match otherwise
 *
 *  Returns false while the user is loading. */
export function useCan(permission: string): boolean {
  const { user } = useAuthState();
  if (!user) return false;
  if (permission === "") return true;
  return user.permissions.some((have) => matches(have, permission));
}

function matches(have: string, want: string): boolean {
  if (have === "*") return true;
  if (have.endsWith(".*")) return want.startsWith(have.slice(0, -1));
  return have === want;
}
